import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
} from '@mui/material'
import Decimal from 'decimal.js'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CalculatePanel from './CalculatePanel'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import CloseDialogButton from 'components/Dialog/CloseDialogButton'
interface ICalculatorDialogProps {
    initAmount: number
    open: boolean
    onClose: () => void
    onConfirm: (amount: Decimal) => void
    quickButtons: number[]
}
export function CalculatorDialog({
    initAmount,
    open,
    onClose,
    onConfirm,
    quickButtons,
}: ICalculatorDialogProps) {
    const { isMobile } = useScreenSize()
    const [amount, setAmount] = useState(initAmount)
    const miniQuickBottons = useMemo(() => {
        const newQuickBottons = [...quickButtons]
        return newQuickBottons
    }, [quickButtons])
    const { t } = useTranslation()

    return (
        <Dialog fullScreen={isMobile} onClose={onClose} open={open}>
            {!isMobile && (
                <CloseDialogButton
                    dialogName="calculator dialog"
                    onClick={onClose}
                />
            )}
            <DialogContent
                sx={{ overflow: 'hidden', px: isMobile ? 1 : undefined }}
            >
                <Box>
                    <CalculatePanel
                        hideQuickButtons={miniQuickBottons.length === 0}
                        quickButtons={miniQuickBottons}
                        initialValue={initAmount}
                        onChange={setAmount}
                        minValue={0}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="primary" onClick={onClose}>
                    {t('button.cancel')}
                </Button>
                <Button
                    color="primary"
                    onClick={() => onConfirm(new Decimal(amount))}
                >
                    {t('button.done')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
